import type { AppointmentResponse } from '@store/generated/appointments';

export type {
  BatchCheckRequest,
  BatchCheckResponse,
  BatchProgressResponse,
} from '@store/generated/eligibility';

// Re-export batch eligibility hooks from patient-coverages (canonical home for eligibility API)
export {
  useGetBatchProgressQuery,
  useRunBatchEligibilityMutation,
} from '@features/patient-coverages/store/api';

// Re-export the appointments query from the appointments feature
// so we share cache/tags instead of double-enhancing the endpoint.
export { useListAppointmentsQuery as useGetUpcomingAppointmentsQuery } from '@features/appointments';

// ── Helpers ──────────────────────────────────────────────────────────

/**
 * Deduplicate appointments by patient_id, keeping the soonest one.
 */
export function dedupeByPatient(appointments: AppointmentResponse[]): AppointmentResponse[] {
  const map = new Map<string, AppointmentResponse>();
  for (const appt of appointments) {
    const pid = appt.patient?.patient_id;
    if (!pid) continue;
    const existing = map.get(pid);
    if (!existing || new Date(appt.start_time) < new Date(existing.start_time)) {
      map.set(pid, appt);
    }
  }
  return Array.from(map.values());
}
